// Computes agent profile completeness percentage and missing-field checklist.
// Each item is equally weighted. Bio requires at least 30 chars to count.

const ITEMS = [
    { key: "photo_url", label: "Profile photo", check: (p) => !!(p?.photo_url && p.photo_url.trim()) },
    { key: "phone", label: "Phone number", check: (p) => !!(p?.phone && p.phone.trim()) },
    { key: "calendly_link", label: "Calendly booking link", check: (p) => !!(p?.calendly_link && p.calendly_link.trim()) },
    { key: "bio", label: "Bio (30+ chars)", check: (p) => !!(p?.bio && p.bio.trim().length >= 30) },
    { key: "website_url", label: "Company website", check: (p) => !!(p?.website_url && p.website_url.trim()) },
    { key: "license_states", label: "Licensed states", check: (p) => Array.isArray(p?.license_states) && p.license_states.length > 0 },
    { key: "zip_codes", label: "ZIP territory", check: (p) => Array.isArray(p?.zip_codes) && p.zip_codes.length > 0 },
];

export function profileCompleteness(agent) {
    if (!agent) return { percent: 0, completed: [], missing: [], total: ITEMS.length };
    const completed = [];
    const missing = [];
    ITEMS.forEach((it) => {
        if (it.check(agent)) completed.push(it);
        else missing.push(it);
    });
    const percent = Math.round((completed.length / ITEMS.length) * 100);
    return { percent, completed, missing, total: ITEMS.length };
}

// For live form state (AgentProfile page), maps form -> agent-like shape
export function completenessFromForm(form, zipsRaw) {
    const zip_codes = (zipsRaw || "")
        .split(/[\s,;\n]+/)
        .map((z) => z.trim())
        .filter(Boolean);
    return profileCompleteness({
        photo_url: form.photo_url,
        phone: form.phone,
        calendly_link: form.calendly_link,
        bio: form.bio,
        website_url: form.website_url,
        license_states: form.license_states,
        zip_codes,
    });
}
